import { SELLER_BADGE_LABELS, type SellerBadge } from "@hybrid-escrow/shared";

/** Earned, server-computed trust signals — see apps/api/src/services/badges.ts. Renders nothing
 *  for a seller with no badges yet, rather than an empty wrapper element. */
export function SellerBadges({ badges }: { badges: SellerBadge[] }) {
  if (badges.length === 0) return null;
  return (
    <span className="row" style={{ gap: "var(--space-1)", display: "inline-flex" }}>
      {badges.map((badge) => (
        <span key={badge} className="badge badge--success text-sm">
          ★ {SELLER_BADGE_LABELS[badge]}
        </span>
      ))}
    </span>
  );
}
